import BlogPlugin from './blog-plugin/blog-plugin';
import ErrorHandlerPlugin from './error-handler-plugin/error-handler-plugin';
import EventsTracking from './events-tracking/events-tracking';
import ExitModalHandlerPlugin from './exit-modal-handler/exit-modal-handler';
import ModalHandlerPlugin from './modal-handler/modal-handler';
import PolyfillsPlugin from './polyfills-plugin/polyfills-plugin';
import ProfilePopupContainerPlugin from './profile-popup-container/profile-popup-container';
import SignupModal from './signup-modal/signup-modal';
import ScrollHandlerPlugin from './scroll-handler/scroll-handler';
import TrackingHandlerPlugin from './tracking-handler/tracking-handler';

export default [
  BlogPlugin,
  ErrorHandlerPlugin,
  EventsTracking,
  ExitModalHandlerPlugin,
  ModalHandlerPlugin,
  PolyfillsPlugin,
  ProfilePopupContainerPlugin,
  SignupModal,
  ScrollHandlerPlugin,
  TrackingHandlerPlugin,
];
